import { Affix } from "@mantine/core";
export default Affix;
